/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeDialogTime } from "../../d-dialog-time";
import { DThemeWhiteDialogFitted } from "./d-theme-white-dialog-fitted";

export class DThemeWhiteDialogTime extends DThemeWhiteDialogFitted implements DThemeDialogTime {}
